import { Link } from "react-router-dom";
import { MonoText } from "@/components/ui/CopyButton";
import { Button } from "@/components/ui/Button";

export function NotFoundPage() {
  return (
    <div className="max-w-xl mx-auto px-4 py-20 text-center">
      <MonoText size="lg" color="status-failed">▓▓ 404 ▓▓</MonoText>
      <h1 className="mt-4 font-sans text-3xl text-ink-primary">Route not found</h1>
      <p className="mt-2 font-mono text-xs text-ink-muted">
        The requested resource does not exist in this terminal.
      </p>
      <Link to="/" className="inline-block mt-6">
        <Button variant="primary">Return to Terminal</Button>
      </Link>
    </div>
  );
}